// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container__1ObZF","vision":"about_vision__2t3CL","microAnimations":"about_microAnimations__VVvaG","light":"about_light__1wjk-"};